import { render, staticRenderFns } from "./AnexosTab.vue?vue&type=template&id=870f18e0"
import script from "./AnexosTab.vue?vue&type=script&lang=js"
export * from "./AnexosTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports